<main class="auth-page">
  <!-- Left — form panel -->
  <div class="auth-form-col auth-form-col--login">
    <span class="auth-topband" aria-hidden="true"></span>

    <div class="auth-form-col__inner">
      <div class="auth-topbar auth-topbar--flush">
        <a [routerLink]="['/portal']" class="auth-backlink">
          <i class="bi bi-arrow-left auth-btn__back"></i>{{ "auth.BackToPortal" | translate }}
        </a>
        <app-lang-toggle></app-lang-toggle>
      </div>

      <!-- Brand -->
      <div class="auth-brandrow">
        <a href="/" class="auth-brandrow__tile" [class.auth-brandrow__tile--custom]="branding.logoUrl">
          <img *ngIf="branding.logoUrl; else defaultTile" [src]="branding.logoUrl" [alt]="branding.name || ''" />
          <ng-template #defaultTile><i class="bi bi-mortarboard-fill"></i></ng-template>
        </a>
        <div class="auth-brandrow__meta">
          <p class="auth-brandrow__name">{{ branding.name || ("app.Menassaty" | translate) }}</p>
          <p class="auth-brandrow__sub">{{ "auth.PlatformSub" | translate }}</p>
        </div>
      </div>

      <!-- Heading -->
      <div class="auth-heading">
        <h1>{{ "auth.WelcomeBack" | translate }} 👋</h1>
        <p>{{ "auth.SignInSub" | translate }}</p>
      </div>

      <form class="auth-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div>
          <label for="email" class="auth-label">{{ "auth.EmailAddress" | translate }}</label>
          <div class="auth-field">
            <i class="bi bi-envelope auth-field__lead" aria-hidden="true"></i>
            <input type="email" id="email" formControlName="email" class="form-control"
              [placeholder]="'auth.EmailPlaceholder' | translate" />
          </div>
          <div class="auth-hint auth-hint--error"
            *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            <i class="bi bi-exclamation-triangle"></i>{{ "auth.InvalidEmail" | translate }}
          </div>
        </div>

        <div>
          <label for="password" class="auth-label">{{ "auth.Password" | translate }}</label>
          <div class="auth-field">
            <i class="bi bi-lock auth-field__lead" aria-hidden="true"></i>
            <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
              class="form-control" placeholder="••••••••••••" />
            <button type="button" class="auth-field__eye" (click)="togglePassword()"
              [attr.aria-label]="'app.ShowPassword' | translate">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
          <div class="auth-hint auth-hint--error"
            *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <i class="bi bi-exclamation-triangle"></i>{{ "auth.PasswordMinLong" | translate }}
          </div>
        </div>

        <!-- Remember + forgot -->
        <div class="auth-row">
          <label class="auth-check">
            <input type="checkbox" formControlName="rememberMe" />
            <span class="auth-check__box" aria-hidden="true"><i class="bi bi-check"></i></span>
            <span class="auth-check__label">{{ "auth.RememberMe" | translate }}</span>
          </label>
          <a [routerLink]="['/account/forget-password']" class="auth-row__link">
            {{ "auth.ForgotPassword" | translate }}
          </a>
        </div>

        <button type="submit" class="auth-btn auth-btn--gradient" [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <ng-container *ngIf="!isLoading">
            <i class="bi bi-person"></i>
            <span>{{ "auth.SignInToAccount" | translate }}</span>
            <i class="bi bi-chevron-right auth-btn__chev"></i>
          </ng-container>
        </button>
      </form>

      <!-- Footer links -->
      <div class="auth-footlinks">
        <p>
          {{ "auth.NoAccount" | translate }}
          <a [routerLink]="['/account/register']">{{ "auth.CreateOne" | translate }}</a>
        </p>
        <p class="auth-footlinks__muted">
          {{ "auth.WantToRunAcademy" | translate }}
          <a [routerLink]="['/portal/become-a-tenant']">
            {{ "auth.JoinAsTenant" | translate }} <span class="auth-arrow">&rarr;</span>
          </a>
        </p>
      </div>
    </div>

    <p class="auth-copyright">&copy; {{ year }} {{ "auth.Copyright" | translate }}</p>
  </div>

  <!-- Right — immersive panel -->
  <app-auth-hero></app-auth-hero>
</main>
